module.exports = __webpack_public_path__ + "images/bubbleDark.f629878a.webp";